import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import Authentication from "../Authentication/Authentication";
import SearchP from "../../Component/SearchP/SearchP";
import * as actionCreator from "../../Store/actions/index";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import ContactNow from "../../Component/ContactNow/ContactNow";
import BottomToolBar from "../../Component/Navigation/BottomToolBar/BottomToolBar";
import CommingSoon from "../../Component/LandingPage/CommingSoon/CommingSoon";

class SearchPage extends Component {
    state = {
        brand: null,
        showComponent: true,
        searchInput: '',
        showBackdrop: false,
        hideSearchOption: false,
        windoWidth: 0,
        // Auth related :
        showAuth: false,
        authMode: 'signIn'
    }

    componentDidMount() {
        this.setState({
            windoWidth: window.innerWidth
        })
        const query = new URLSearchParams(this.props.location.search);
        let updatedBrand;
        for (let param of query.entries()) {
            updatedBrand = param[1]
        }
        this.setState({ brand: updatedBrand })
        const vehicleType = localStorage.getItem('vehicleType') ? localStorage.getItem('vehicleType') : this.props.vehicleType
        this.props.onGetVehicleItems(vehicleType, 1, updatedBrand)
        window.addEventListener('resize', this.hiedSearchOption)
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.vehicleType !== nextProps.vehicleType) {
            this.props.onGetVehicleItems(nextProps.vehicleType)
        }
        return true
    }


    reLoadCompnentHandler = () => {
        this.setState({ showComponent: false })
        setTimeout(() => {
            this.showComponent()
        }, 300)
    }

    showComponent = () => {
        this.setState({ showComponent: true })
    }

    sortByHandler = (sortype) => {
        let url = this.props.currentURL
        switch (sortype) {
            case 'Latest':
                url = url + '&sorting=latest_to_oldest'
                break;
            case 'Oldest':
                url = url + '&sorting=oldest_to_latest'
                break;
            case 'PriceA':
                url = url + '&sorting=price_asc'
                break;
            case 'PriceD':
                url = url + '&sorting=price_desc'
                break;
            default:
                url = url + '&sorting=latest_to_oldest'
                break;
        }
        this.props.onGetVehicleItems(this.props.vehicleType, 1, null, url)
    }

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }

    reLoadSearchPageHandler = () => {
        window.location.reload(false)
    }

    closeBackdropHandler = () => {
        this.setState({
            showBackdrop: false
        })
    }

    OpenDrawerHandler = () => {
        this.setState({ showBackdrop: true })
    }

    hiedSearchOption = () => {

        this.setState({
            windoWidth: window.innerWidth
        })

    }

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.hiedSearchOption)
    }

    render() {
        return (
            <Fragment>
                {this.state.showAuth ?
                    <Authentication
                        showAuth={this.state.showAuth}
                        showAuthHandler={this.showAuthHandler}
                        authMode={this.state.authMode} />
                    :
                    null}
                <MainToolBar
                    searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user} />
                {this.props.commingSoon ?
                    <Fragment>
                        <BottomToolBar changeType={(type) => { this.props.onChangeVehicleType(type) }}/>
                        <CommingSoon />
                    </Fragment>
                    :
                    <SearchP
                        viewType={this.props.viewType}
                        vehicleItems={this.props.vehicleItems}
                        itemsLoading={this.props.itemsLoading}
                        brand={this.state.brand}
                        showComponent={this.state.showComponent}
                        reLoadCompnent={this.reLoadCompnentHandler}
                        sortBy={(type) => this.sortByHandler(type)}
                        sortType={this.state.sortedBy}
                        showBackdrop={this.state.showBackdrop}
                        closeBackdrop={this.closeBackdropHandler}
                        OpenDrawer={this.OpenDrawerHandler}
                        windoWidth={this.state.windoWidth}
                        routerProps={this.props}
                        user={this.props.user}
                        wishIdsArray={this.props.wishIdsArray}
                        showAuthHandler={this.showAuthHandler}
                        AddItemToUserWishList={this.props.onAddItemToUserWishList}
                        addingItem={this.props.addingItem}
                    />
                }
                <ContactNow />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        viewType: state.SearchP.viewType,
        vehicleType: state.SearchP.vehicleType,
        //Items:
        vehicleItems: state.SearchP.vehicleItems,
        itemsLoading: state.SearchP.itemsLoading,
        error: state.SearchP.error,
        currentURL: state.SearchP.currentURL,
        //comming soon :
        commingSoon: state.SearchP.commingSoon,
        // Auth related : 
        user: state.Auth.user,
        // WishList related :
        wishIdsArray: state.WishList.wishIdsArray,
        addingItem: state.WishList.addingItem
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onGetVehicleItems: (type, pageNum, brand, url) => { dispatch(actionCreator.getVehicleItems(type, pageNum, brand, url)) },
        onAddItemToUserWishList: (itemId, token) => { dispatch(actionCreator.addItemToUserWishList(itemId, token)) },
        onChangeVehicleType: (type) => { dispatch(actionCreator.changeVehicleType(type)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
